export default "__VITE_ASSET__DfqvKvXc__"